<template>
  <div>
    <ItemRow
      v-bind="$attrs"
      v-on="$listeners"
    >
      <ItemWithLabel
        v-for="(column, index) in columns"
        :key="index"
        :column="column"
        :data-test-id="`ScheduledEventRow__${column.dataFieldName}`"
      >
        <ParagraphBody
          v-if="column.dataFieldName === 'state'"
          weight="bold"
        >
          {{ getActionText }}
        </ParagraphBody>
        <ParagraphBody
          v-else-if="column.dataFieldName === 'scheduledDate'"
        >
          {{ getDate }}
        </ParagraphBody>
        <ButtonDelete
          v-else
          @click="handleDeleteScheduledStateChange"
        />
      </ItemWithLabel>
    </ItemRow>
    <DeleteScheduledEvent
      v-if="showDeleteEventModal"
      :action="getAction"
      :item="{
        ...itemData,
        _id: itemData.systemUserId,
      }"
      :showModal="showDeleteEventModal"
      @close="closeModal"
    />
  </div>
</template>

<script>
import {
  ButtonDelete,
  ItemRow,
  ItemWithLabel,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { ModuleConsts } from 'client/util/Constants';
import { capitalize } from 'lodash';
import {
  dateDisplayFormat,
  userStateActionType,
} from 'client/systemusers/constants/SystemUserConstants';
import DateUtil from 'client/util/DateUtil';
import DeleteScheduledEvent from 'client/systemusers/Modals/DeleteScheduledEvent.vue';

export default {
  name: 'ScheduledEventRow',

  components: {
    ButtonDelete,
    DeleteScheduledEvent,
    ItemRow,
    ItemWithLabel,
    ParagraphBody,
  },

  dateDisplayFormat,

  props: {
    columns: {
      type: Array,
      required: true,
    },

    itemData: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    showDeleteEventModal: false,
  }),

  computed: {
    getAction() {
      const { activated } = ModuleConsts.systemUser.accountStates;
      const { activate, suspend } = userStateActionType;

      return this.itemData.state === activated ? activate : suspend;
    },

    getActionText() {
      return `${capitalize(this.getAction)}`;
    },

    getDate() {
      const eventDate = DateUtil.customFormatDate(
        this.itemData.scheduledDate,
        this.$options.dateDisplayFormat,
      );
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      return `${eventDate} (${timezone})`;
    },
  },

  methods: {
    closeModal() {
      this.showDeleteEventModal = false;
    },

    handleDeleteScheduledStateChange() {
      this.showDeleteEventModal = true;
    },
  },
};
</script>
